export const SHIFT_HANDOVER_DISABLED_MESSAGE = "未开启交接班功能，可前往“设置”-“收银基础设置”开启"

export const isShiftHandoverEnabled = (status: unknown) => status === true || Number(status) === 1

export const buildShiftHandoverAvailability = (status: unknown) => {
  const enabled = isShiftHandoverEnabled(status)
  return {
    enabled,
    disabled: !enabled,
    message: enabled ? "" : SHIFT_HANDOVER_DISABLED_MESSAGE,
  }
}
